<template>
  <v-app>
    <!-- <Search/> -->
     <router-view></router-view>
     <footer>
       <v-layout>
         <v-flex md4 xs6 text-xs-left class="footer-text">
          <h4 class="font-weight-light"><i class="fab fa-facebook"></i>
            younghappy.se <br>
            <i class="fab fa-line"></i> @younghappy
          </h4>
         </v-flex>

         <v-flex md4 xs0>

         </v-flex>

         <v-flex md4 xs12>
           <v-layout wrap>
             <v-flex md6 xs1 text-xs-right class="phone">
             <i class="fas fa-phone-volume"></i>
           </v-flex>
           <v-flex md3 xs0 text-xs-left class="call-center">
             <p class="font-weight-regular">             
             YOUNGHAPPY <br> CALL CENTER
           </p>
           </v-flex>
           <v-flex md3 xs6 class="call-center-tel" text-xs-left text-md-left>
             <p class="font-weight-regular">: 065-506-2889</p>
           </v-flex>
           </v-layout>
           
         </v-flex>
       </v-layout>
    </footer>
  </v-app>
</template>

<script>
import Search from './components/Search'

export default {
  name: 'App',
  components: {
    Search
  },
  data () {
    return {
      //
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Prompt:300,400');

html, body {
  font-family: 'Prompt', sans-serif;
}

body {
  font-family: 'Prompt', sans-serif;
}

#app {
  font-family: 'Prompt', sans-serif;
}

footer {
  position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 70px;
    background-color: #97c763;
    color: white;
    text-align: center;
}

.footer-text {
  margin-left: 10px;
  margin-top: 10px;
}

.call-center {
  margin-top: 15px;
}

.call-center-tel {
  margin-top: 25px;
}
.phone {
  margin-top: 22px;
  padding-right: 10px;
  font-size: 25px;
}
</style>

